<template>
  <div class="d-flex fd-column">
    <span v-for="(error, index) in errors" :key="index" class="d-flex">{{ error.message }}</span>
  </div>
</template>

<script>
export default {
  name: 'error-messages',
  props: {
    error: {
      type: [Error, String],
      required: true,
    },
    defaultMessage: {
      type: String,
      default: 'Something went wrong. Please try again later...',
    },
  },
  computed: {
    errors () {
      if (typeof this.error === 'string') {
        return [{ message: this.error }];
      }

      if (this.error.response) {
        return this.error.response.data.errors;
      }

      return [{ message: this.defaultMessage }];
    },
  },
};
</script>
